import { call, put, select } from 'redux-saga/effects';
import { saveTaxRatesFailure, saveTaxRatesSuccess } from '../actions';
import { saveTaxRates } from '../api';
import { SaveTaxRatesRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnDrawerOff } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { refreshConnectionTaxRatesRequest } from '../actions';
import { updateOrganisationTaxRates } from 'store/organisation/actions';
import { getOrgOrganisations } from 'store/organisation/selectors';
import { Organisation } from 'store/organisation/models';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* saveTaxRatesSaga(action: SaveTaxRatesRequestAction) {
  try {
    let err: ApiError | null;
    const { connectionId, rates } = action.payload;
    const response: ApiResponse = yield call(saveTaxRates, connectionId, rates);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const taxRates = response?.data?.taxRates ?? [];
    yield put(saveTaxRatesSuccess(taxRates, connectionId));

    const organisations: Organisation[] | undefined = yield select(
      getOrgOrganisations
    );
    const org = organisations?.find((o) => o.connectionId === connectionId);
    yield put(
      updateOrganisationTaxRates(
        connectionId,
        taxRates,
        org?.taxEnabled ?? false
      )
    );

    // Full refresh (incl. taxRatesUnique for QuickBooks) for checklist and tabs.
    yield put(refreshConnectionTaxRatesRequest(connectionId, true));

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.tax-rates-saved-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(turnDrawerOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveTaxRatesFailure());
  }
}

